export enum placeholdersEnglish {
  center = 'Center',
  doctorName = 'Doctor name',
}

export enum placeholdersSpanish {
  center = 'Centro',
  doctorName = 'Nombre del médico',
}

export enum placeholdersPortugese {
  center = 'Centro',
  doctorName = 'Nome do médico',
}

export enum AssessmentStatusIds {
  notStarted = 1,
  completed = 2,
  inProgress = 3,
}

export enum assessmentTypeId {
  patientAssisted = 1,
  HCPAssisted = 2,
}

export enum scheduleCodeEnum {
  A1 = '1A',
  A2 = '2A',
  A3 = '3A',
  A4 = '4A',
  A5 = '5A',
  A6 = '6A',
  A7 = '7A',
  A8 = '8A',
}
